import React, { useContext, useMemo, useState } from 'react';

const AssociationSchedulingContext = React.createContext(null);

export const useAssociationSchedulingContext = () => useContext(AssociationSchedulingContext) || {};

export const AssociationSchedulingProvider = ({ surfaces = [], office, ...props }) => {
  const [colOffset, setColOffset] = useState(0);

  const value = useMemo(() => ({
    surfaces,
    office,
    colOffset,
    setColOffset,
  }), [colOffset, office, surfaces]);

  return <AssociationSchedulingContext.Provider value={value} {...props} />
}
